import { sendToBot } from '../lib/telegram.js';
import { useAppStore } from '../store.js';

export function ActionButton({ action, label, variant = 'primary', payload = {} }) {
  const showToast = useAppStore((s) => s.showToast);
  const runAction = useAppStore((s) => s.runAction);
  const actionPending = useAppStore((s) => s.actionPending);
  const disabled = actionPending === action;

  const onClick = async () => {
    const actionPayload = { action, label, ...payload };
    const apiResult = await runAction(actionPayload);
    const botResult = sendToBot('miniapp_action', { ...actionPayload, api: { ok: apiResult?.ok, changed: apiResult?.changed } });

    if (apiResult?.message) {
      showToast(apiResult.message);
    } else if (botResult.sentToTelegram) {
      showToast(`Отправлено в бот: ${label}`);
    } else if (apiResult?.source === 'mock') {
      showToast(`Browser fallback: ${label}`);
    } else {
      showToast(`API: ${label}`);
    }
  };

  return <button className={variant === 'secondary' ? 'secondary' : ''} onClick={onClick} disabled={disabled}>{disabled ? '...' : label}</button>;
}
